import type { ReceiptTaxFeeItemDTO, RideDTO } from '@/api/generated/types';

export interface RideCharged {
  /** The ride's charge before tax and fees (RideDTO.charge). */
  charge: number;
  /** Tax and fees on top: the billing snapshot's total, else the legacy combined ride tax. */
  taxAndFee: number;
  /** What the rider paid for the ride: charge + tax and fees. */
  total: number;
  /** The tax and fee lines, when the billing snapshot has them. */
  items: ReceiptTaxFeeItemDTO[];
}

const cents = (v: number) => Math.round(v * 100) / 100;

/**
 * The amount a rider was actually charged for a ride, as the admin gateway totals it for receipts
 * (charge + totalTaxAndFeeAmount, falling back to the legacy `tax`). RideDTO.charge alone is
 * pre-tax, so it does not match the amount a rider quotes. Null while the ride has no charge yet.
 */
export function rideCharged(r: Pick<RideDTO, 'charge' | 'tax' | 'metaData'>): RideCharged | null {
  if (r.charge == null) return null;
  // `||`, not `??`: a snapshot total of 0 next to a legacy tax means the snapshot missed it
  const taxAndFee = r.metaData?.totalTaxAndFeeAmount || r.tax || 0;
  const items = [...(r.metaData?.taxFeeItems ?? [])].filter((i) => i.amount).sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
  return { charge: r.charge, taxAndFee, total: cents(r.charge + taxAndFee), items };
}
